module.exports = __webpack_public_path__ + "img/logotipo.d5904e1a.svg";